module.exports = __webpack_public_path__ + "img/6_65.776c8d01.png";